"use client";

import React from "react";
import SectionHeading from "./section-heading";
import { motion } from "framer-motion";
import { useSectionInView } from "@/lib/hooks";
import { profile } from "@/lib/data";
import { HiDownload, HiEye } from "react-icons/hi";
import Link from "next/link";

export default function Resume() {
  const { ref } = useSectionInView("Resume");

  return (
    <motion.section
      id="resume"
      ref={ref}
      className="mb-20 sm:mb-28 w-[min(100%,48rem)] text-center scroll-mt-28"
      initial={{
        opacity: 0,
      }}
      whileInView={{
        opacity: 1,
      }}
      transition={{
        duration: 1,
      }}
      viewport={{
        once: true,
      }}
    >
      <SectionHeading>My Resume</SectionHeading>

      <p className="text-white/80 -mt-6 mb-8">
        Download my resume to learn more about my experience, skills, and qualifications. You can also preview it online before downloading.
      </p>

      <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
        <Link href="/resume">
          <motion.button
            className="group flex items-center gap-3 bg-white/10 text-white px-8 py-4 rounded-xl hover:bg-white/20 transition-all shadow-md hover:shadow-lg font-medium"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <HiEye className="text-2xl" />
            <div className="flex flex-col items-start">
              <span className="text-xs text-gray-300">View Online</span>
              <span className="font-semibold">Preview Resume</span>
            </div>
          </motion.button>
        </Link>

        <a href={profile.resumeLink} download>
          <motion.button
            className="group flex items-center gap-3 bg-gradient-to-br from-blue-600 to-blue-700 text-white px-8 py-4 rounded-xl hover:from-blue-700 hover:to-blue-800 transition-all shadow-md hover:shadow-lg font-medium"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <HiDownload className="text-2xl" />
            <div className="flex flex-col items-start">
              <span className="text-xs text-blue-100">Download PDF</span>
              <span className="font-semibold">Download Resume</span>
            </div>
          </motion.button>
        </a>
      </div>
    </motion.section>
  );
}

